module.exports = __webpack_public_path__ + "img/banner-04.d128d53a.jpg";